module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_8017.e014de66.png";